<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"></a><a id="frontmatter01"></a>PROLOGUE</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><em>How has it come to this?</em></p>
<p class="indent-para"><em>Gina doesn’t know—but she looks across the warehouse floor at the three men and decides she can’t take any more of it. She has to leave. It’s just too much.</em></p>
<p class="indent-para"><em>“I’m . . . I’ll be outside,” she says, though it’s barely audible.</em></p>
<p class="indent-para"><em>She turns and walks over to the metal door. Her hand is shaking as she opens it. She steps outside, into the cold night air.</em></p>
<p class="indent-para"><em>With her back to the closed door, she takes a deep breath and closes her eyes.</em></p>
<p class="indent-para"><em>After a moment, she opens them again. It’s a fairly desolate scene out here. In one direction the floodlit yard of this industrial park leads to a graffiti-covered wall at the back of a housing estate. In the other direction there are more warehouses, and you can just about see the road up ahead—which is dead quiet at the moment. Five minutes west of here there is a major roundabout, and even at this time of night it would be busy with traffic.</em></p>
<p class="indent-para"><em>Gina can’t believe she’s feeling lonely for traffic.</em></p>
<p class="indent-para"><em>She looks up. The sky is clear and the moon is so dazzlingly bright that it’s almost pulsating. She stays huddled in the doorway, puts her back to the wind and tries to get one of Fitz’s cigarettes going, cupping her hand around it and flicking the Zippo repeatedly until it takes.</em></p>
<p class="indent-para"><em>Then, inhaling deeply, she steps away from the door. The intense glow from the moon tonight, combined with the orange wash of the floodlights, gives the space out here an air of unreality, the eerie and soulless feel of a virtual environment. She wishes that that’s what <a id="page_2"></a>this whole thing were—a simulation, a game, something she could tinker with and reprogram. But she knows there is no—can be no—digital equivalent, or even approximation, of anxiety, of guilt, of fear.</em></p>
<p class="indent-para"><em>This is real and it’s happening now.</em></p>
<p class="indent-para"><em>But what if Terry Stack finds out where Mark Griffin is? Will that mean it’s been worth it? Will that mean she did the right thing by calling him?</em></p>
<p class="indent-para"><em>Or is it all too toxic now for such a clean exchange?</em></p>
<p class="indent-para"><em>As she takes her next drag on the cigarette, Gina hears a weird sound. It is short and shrill and penetrating. She looks up and remains still for a few seconds, listening.</em></p>
<p class="indent-para"><em>She really can’t be sure that the sound wasn’t just some form of distortion carried here from a distance by the wind.</em></p>
<p class="indent-para"><em>She closes her eyes.</em></p>
<p class="indent-para"><em>But neither can she be sure that it didn’t come from nearby, from directly behind her, and that it wasn’t a scream.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?3565dea0